import { render, staticRenderFns } from "./ShippingCompanySearch.vue?vue&type=template&id=2f0490a4"
import script from "./ShippingCompanySearch.vue?vue&type=script&lang=js"
export * from "./ShippingCompanySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports